export default __webpack_public_path__ + "static/media/profile.882ef0c9.svg";